import React from "react";
import styles from './SVG.module.css'
/**
 * Renders a single semi-circle shape with a centered semi-circular bite.
 * The geometry is defined parametrically using only arcs.
 */

export const SemiWithBite = ({
  outerDiameter,
  innerDiameter,
  rotation = 0,
  x = 0,
  y = 0,
  fill = "#000",
}) => {
  const outerRadius = outerDiameter / 2;
  const innerRadius = innerDiameter / 2;

  // Compound path: outer semi-circle followed by reversed inner semi-circle
  const path = `
    M ${-outerRadius},0
    A ${outerRadius},${outerRadius} 0 0,1 ${outerRadius},0
    L ${innerRadius},0
    A ${innerRadius},${innerRadius} 0 0,0 ${-innerRadius},0
    Z
  `;

  return (
    <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
      <path d={path} fill={fill} />
    </g>
  );
};


export const CircleWithHole = ({
  outerDiameter,
  innerDiameter,
  rotation = 0,
  x = 0,
  y = 0,
  fill = "#000",
}) => {
  const outerRadius = outerDiameter / 2;
  const innerRadius = innerDiameter / 2;

  // Compound path: outer semi-circle followed by reversed inner semi-circle
  const path = `
    M ${outerRadius},0
    A ${outerRadius},${outerRadius} 0 1,0 ${-outerRadius},0
    A ${outerRadius},${outerRadius} 0 1,0 ${outerRadius},0
    M ${innerRadius},0
    A ${innerRadius},${innerRadius} 0 1,1 ${-innerRadius},0
    A ${innerRadius},${innerRadius} 0 1,1 ${innerRadius},0
    Z
  `;

  return (
    <>
      <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
        <path d={path} fill={fill} />
      </g>
    </>
  );
};

/**
 * Example: renders two semi-with-bite shapes positioned relative to each other.
 */
export const SemiWithBitePair = ({
  // outerDiameter,
  // innerDiameter,
  fill = "#000",
  scrollState,
  height,
  mask,
  logoScale,
  maskId
}) => {

    let xVaryModifier = (height*logoScale)/12.34675; //9.69;
    let yVaryModifier = (height*logoScale)/5.61954; //21.29;

    let outerDiameter = (height*logoScale)/2;
    let outerDiameterConst = (height)/2;
    let innerDiameter = (height*logoScale)/3.32333;

    if(mask){
      return (
        <svg className={styles.logoStyle} viewBox={`0 0 ${height} ${height}`} preserveAspectRatio="xMidYMid meet" style={{ width: height, height: height }}>
          <mask id={maskId}>
            {scrollState > 0? <><SemiWithBite
              outerDiameter={outerDiameter}
              innerDiameter={innerDiameter}
              x={outerDiameterConst+(scrollState*(xVaryModifier/2))}
              y={outerDiameterConst-(scrollState*(yVaryModifier/2))}
              // x={outerDiameter}
              // y={outerDiameter}
              rotation={-47.5}
              fill={fill}
            /><SemiWithBite
              outerDiameter={outerDiameter}
              innerDiameter={innerDiameter}
              x={outerDiameterConst-(scrollState*(xVaryModifier/2))}
              y={outerDiameterConst+(scrollState*(yVaryModifier/2))}
              rotation={132.5}
              fill={fill}
            /></> : <CircleWithHole
              outerDiameter={outerDiameter}
              innerDiameter={innerDiameter}
              x={outerDiameterConst+(scrollState*(xVaryModifier/2))}
              y={outerDiameterConst-(scrollState*(yVaryModifier/2))}
              // x={outerDiameter}
              // y={outerDiameter}
              rotation={-47.5}
              fill={fill}
            />}
          </mask>
        </svg>
      );
    } else {
      return (
        <svg className={styles.logoStyle} viewBox={`0 0 ${height} ${height}`} preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%" }}>
            {scrollState > 0? <><SemiWithBite
              outerDiameter={outerDiameter}
              innerDiameter={innerDiameter}
              x={outerDiameterConst+(scrollState*(xVaryModifier/2))}
              y={outerDiameterConst-(scrollState*(yVaryModifier/2))}
              // x={outerDiameter}
              // y={outerDiameter}
              rotation={-47.5}
              fill={fill}
            /><SemiWithBite
              outerDiameter={outerDiameter}
              innerDiameter={innerDiameter}
              x={outerDiameterConst-(scrollState*(xVaryModifier/2))}
              y={outerDiameterConst+(scrollState*(yVaryModifier/2))}
              rotation={132.5}
              fill={fill}
            /></> : <CircleWithHole
              outerDiameter={outerDiameter}
              innerDiameter={innerDiameter}
              x={outerDiameterConst+(scrollState*(xVaryModifier/2))}
              y={outerDiameterConst-(scrollState*(yVaryModifier/2))}
              // x={outerDiameter}
              // y={outerDiameter}
              rotation={-47.5}
              fill={fill}
            />}
        </svg>
      );
    }
  
};

// export const SemiWithBitePair = ({
//   outerDiameter,
//   innerDiameter,
//   rotation = 0,
//   x = 0,
//   y = 0,
//   fill = "#000",
//   scrollState
// }) => {
//     let yModifier = 8.5;
//     let xModifier = 39.5;

//     let xVaryModifier = 9.69;
//     let yVaryModifier = 21.29;
//   return (
//     <svg className={styles.logoStyle} viewBox={`0 0 ${outerDiameter*2} ${outerDiameter*2}`} preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height: "100%" }}>
//       <mask id="mask1">
//         {scrollState > 0? <><SemiWithBite
//           outerDiameter={outerDiameter}
//           innerDiameter={innerDiameter}
//           x={outerDiameter+(scrollState*(xVaryModifier/2))}
//           y={outerDiameter-(scrollState*(yVaryModifier/2))}
//           // x={outerDiameter}
//           // y={outerDiameter}
//           rotation={-47.5}
//           fill={fill}
//         /><SemiWithBite
//           outerDiameter={outerDiameter}
//           innerDiameter={innerDiameter}
//           x={outerDiameter-(scrollState*(xVaryModifier/2))}
//           y={outerDiameter+(scrollState*(yVaryModifier/2))}
//           rotation={132.5}
//           fill={fill}
//         /></> : <CircleWithHole
//           outerDiameter={outerDiameter}
//           innerDiameter={innerDiameter}
//           x={outerDiameter+(scrollState*(xVaryModifier/2))}
//           y={outerDiameter-(scrollState*(yVaryModifier/2))}
//           // x={outerDiameter}
//           // y={outerDiameter}
//           rotation={-47.5}
//           fill={fill}
//         />}
//       </mask>
//     </svg>
//   );
// };